import { useEffect, useMemo } from "react";

import * as MdIcons from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import styled from "@emotion/styled";
import { CircularProgress } from "@mui/material";

import useLoading from "~common/hooks/useLoading";
import { getStatistics } from "~store/statistics/actions";
import { selectStatisticsByKey, selectStatisticsFilter } from "~store/statistics/selectors";

const StyledAggregateCard = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.palette.grey[100]};
  border-radius: 20px;
  padding: 20px;
  margin: 10px;
`;

const TitleDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`;
const getIconComponent = (iconName) => {
  //eslint-disable-next-line
  return MdIcons[iconName] || MdIcons.MdHelp; // Default to MdHelp if icon not found
};

const AggregateCard = ({ title, value: valueProp, statisticKey, icon, noKey = false }) => {
  const { projectId } = useParams();
  const { beginDate, endDate } = useSelector(selectStatisticsFilter);
  const [loading, q] = useLoading();
  const dispatch = useDispatch();
  const selectorValue = useSelector(selectStatisticsByKey(statisticKey));
  const value = useMemo(() => (noKey ? valueProp : selectorValue), [noKey, valueProp, selectorValue]);
  const IconComp = useMemo(() => (typeof icon === "string" ? getIconComponent(icon) : icon), [icon]);
  useEffect(() => {
    !noKey && q(dispatch(getStatistics(projectId, [statisticKey], beginDate, endDate, true)));
  }, [dispatch, projectId, q, statisticKey, beginDate, endDate, noKey]);
  return (
    <StyledAggregateCard>
      <TitleDiv>
        <h5>{title}</h5>
        <h4>
          <IconComp />
        </h4>
      </TitleDiv>
      <h1>{loading ? <CircularProgress /> : value}</h1>
    </StyledAggregateCard>
  );
};

export default AggregateCard;

export const AggregateMultiCard = ({ title, statisticKeys = [], icon }) => {
  const { projectId } = useParams();
  const { beginDate, endDate } = useSelector(selectStatisticsFilter);
  const [loading, q] = useLoading();
  const dispatch = useDispatch();

  // store'dan gelen her bir key'in değerini alıp topluyoruz
  const sumValue = useSelector((state) =>
    statisticKeys.reduce((total, key) => {
      const val = selectStatisticsByKey(key)(state);
      return total + (typeof val === "number" ? val : 0);
    }, 0)
  );

  const IconComp = useMemo(() => (typeof icon === "string" ? getIconComponent(icon) : icon), [icon]);

  useEffect(() => {
    if (statisticKeys.length) {
      q(dispatch(getStatistics(projectId, statisticKeys, beginDate, endDate, true)));
    }
  }, [dispatch, projectId, q, statisticKeys, beginDate, endDate]);

  return (
    <StyledAggregateCard>
      <TitleDiv>
        <h5>{title}</h5>
        <h4>
          <IconComp />
        </h4>
      </TitleDiv>
      <h1>{loading ? <CircularProgress size={24} /> : sumValue}</h1>
    </StyledAggregateCard>
  );
};
